"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticsItem = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const classes_1 = require("../../../server/classes");
const DSSL007_List_1 = require("../../DSS/DSSL007/DSSL007_List");
const classes_2 = require("../../base/classes");
const KlassInfo_1 = require("./KlassInfo");
const UserInfo_1 = require("./UserInfo");
exports.StatisticsItem = react_1.default.memo(({ id }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [classId, setClassId] = react_1.default.useState(undefined);
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch((0, classes_2.setClassesData)(undefined));
        };
    }, []);
    const handlerUpdateClassId = async (classId) => {
        const classData = await (0, classes_1.getClassesList)({ id: classId });
        const { total_count, items } = classData.result;
        if (total_count > 0) {
            const classes_data = items.find(i => i.id === classId);
            dispatch((0, classes_2.setClassesData)(classes_data));
            setClassId(classId);
        }
        else {
            dispatch((0, classes_2.setClassesData)(undefined));
            setClassId(null);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "admin-main", style: { gap: 48 } },
            react_1.default.createElement(UserInfo_1.UserInfo, { id: id }),
            react_1.default.createElement(KlassInfo_1.KlassInfo, { id: id, classId: classId, setClassId: handlerUpdateClassId }),
            classId ? (react_1.default.createElement(DSSL007_List_1.DSSL007_List, { isAdmin: true, classId: classId, selectUserId: id })) : null)));
});
